import { render } from "./AdminQuestionsList.vue?vue&type=template&id=02352a1e&scoped=true"
import script from "./AdminQuestionsList.vue?vue&type=script&lang=js"
export * from "./AdminQuestionsList.vue?vue&type=script&lang=js"

import "./AdminQuestionsList.vue?vue&type=style&index=0&id=02352a1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02352a1e"]])

export default __exports__